import { render, staticRenderFns } from "./Awarded.vue?vue&type=template&id=09a6a0ae&scoped=true&"
import script from "./Awarded.vue?vue&type=script&lang=js&"
export * from "./Awarded.vue?vue&type=script&lang=js&"
import style0 from "./Awarded.vue?vue&type=style&index=0&id=09a6a0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6a0ae",
  null
  
)

export default component.exports